/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type PdpRespSimilarItemsFooter_viewer$ref = any;
export type PdpRespSimilarItemsFooterRefetchQueryVariables = {
    isArt: boolean;
    itemId: string;
    isTrade: boolean;
};
export type PdpRespSimilarItemsFooterRefetchQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": PdpRespSimilarItemsFooter_viewer$ref;
    } | null;
};
export type PdpRespSimilarItemsFooterRefetchQuery = {
    readonly response: PdpRespSimilarItemsFooterRefetchQueryResponse;
    readonly variables: PdpRespSimilarItemsFooterRefetchQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "isArt",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "itemId",
    "type": "String!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "isTrade",
    "type": "Boolean!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currency",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "PdpRespSimilarItemsFooterRefetchQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "PdpRespSimilarItemsFooter_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "isArt",
                "variableName": "isArt"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "PdpRespSimilarItemsFooterRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": "isSeoQuicklookEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "SEO_QUICKLOOK"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
          },
          {
            "kind": "ScalarField",
            "alias": "isFavoritesEnabled",
            "name": "isEnabledByLocale",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "FAVORITES"
              }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"FAVORITES\")"
          },
          (v1/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "isArt",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "visuallySimilarGridItems",
                "name": "visualSearch",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 6
                  },
                  {
                    "kind": "Variable",
                    "name": "itemPk",
                    "variableName": "itemId"
                  }
                ],
                "concreteType": "VisualSearchConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VisualSearchEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "categoryPath",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "browseUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "categoryCode",
                            "args": null,
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "ecommerceTrackingParams",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isFurniture",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isCustomizable",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isMultiSku",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "localizedPdpUrl",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "vertical",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "displayPrice",
                            "storageKey": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "isTrade",
                                "variableName": "isTrade"
                              },
                              {
                                "kind": "Literal",
                                "name": "page",
                                "value": "searchAndBrowse"
                              }
                            ],
                            "concreteType": "ItemDisplayPriceType",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "convertedAmountList",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ConvertedAmountList",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "quantityDisplay",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "percentageOff",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "type",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showPriceLabel",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "showPriceVariability",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "lowestShipmentQuote",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ShipmentQuote",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "complimentaryShipping",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "totalAmount",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FinancialAmount",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "convertedAmountList",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "ConvertedAmountList",
                                    "plural": true,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v3/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "serviceMethod",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ShipmentServiceMethod",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isWhiteGlove",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "classification",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemClassification",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "creationDate",
                                "args": null,
                                "storageKey": null
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "creators",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ItemCreator",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "attribution",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "creator",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Creator",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "displayName",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  (v1/*: any*/)
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": "productPhotos",
                            "name": "photos",
                            "storageKey": "photos(limit:1)",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "limit",
                                "value": 1
                              }
                            ],
                            "concreteType": "ItemPhoto",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "placeholder",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "smallPath",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "masterOrZoomPath",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "versions",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ItemPhotoVersion",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "webPath",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              },
                              (v1/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "quickViewDisplay",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "QuickViewDisplayType",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": "mobileTitle",
                                "name": "title",
                                "args": (v5/*: any*/),
                                "storageKey": "title(formatType:\"MOBILE\")"
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "paragraphs",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "QuickViewParagraph",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "key",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "text",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": "mobileText",
                                    "name": "text",
                                    "args": (v5/*: any*/),
                                    "storageKey": "text(formatType:\"MOBILE\")"
                                  }
                                ]
                              }
                            ]
                          },
                          (v1/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "PdpRespSimilarItemsFooterRefetchQuery",
    "id": "app-buyer-finding/237.0.0-2019-10-18T13:55:49.909Z/PdpRespSimilarItemsFooterRefetchQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = 'a7166b709211fbe1bb46817522db949e';
export default node;
